export default __webpack_public_path__ + "static/media/EveningTree.5b87efd2.png";